import gql from 'graphql-tag';
import { STATIC_CONTENT } from '../assets/staticContent';
// import Test from '../assets/header/CTDC_Logo.svg';

// The ideal image size of landingPageHero 1400x600px
// Tile1 Tile2 Tile3 images 293x349 px
// Tile4 image optimum size 600x 436 px
export const landingPageData = {
  callToActionTitle: 'Enabling secure and scalable storage and sharing of cancer data',
  callToActionDescription: 'The General Commons (GC) is part of the Cancer Research Data Commons (CRDC) ecosystem. It provides secure, scalable cloud storage and data sharing capabilities for NCI-funded cancer research. It supports a range of data types, including genomic, proteomic and imaging data, for studies not suited for other CRDC repositories.',
  callToActionDescriptionTitle: 'Explore GC Portal',
  callToActionButtonText: 'EXPLORE GENERAL COMMONS',
  callToActionLink: '/data',
  heroLeftBg: {
    alt: 'Alt tag1',
    img: STATIC_CONTENT.landing.LEFT_SIDE_IMAGE,
  },
  heroRightBg: {
    alt: 'Alt tag1',
    img: STATIC_CONTENT.landing.RIGHT_SIDE_IMAGE,
  },
  landingPageHero: {
    alt: 'Alt tag1',
    img: STATIC_CONTENT.landing.LANDING_PAGE_HERO_IMAGE,
  },
  landingPageTile: {
    alt: 'Alt tag1',
    img: STATIC_CONTENT.landing.TILES_BACKGROUND_GRID_IMAGE,
  },
  landingPageStatsBar: [
    {
      statTitle: 'Studies',
      statAPI: 'numberOfStudies',
      callToActionLink: '/studies',
    },
    {
      statTitle: 'participants',
      statAPI: 'numberOfSubjects',
      callToActionLink: '/data',
    },
    {
      statTitle: 'samples',
      statAPI: 'numberOfSamples',
      callToActionLink: '/data?selectedTab=samples',
    },
    {
      statTitle: 'files',
      statAPI: 'numberOfFiles',
      callToActionLink: '/data?selectedTab=files',
    },
  ],
  tile1: {
    alt: 'Overview of the GC Portal',
    img: STATIC_CONTENT.landing.LANDING_TILE_1_IMAGE,
    titleText: 'ABOUT THE GENERAL COMMONS',
    descriptionText: 'The General Commons (GC) is a data repository under the $$[Cancer Research Data Commons (CRDC)](https://datacommons.cancer.gov/)$$ infrastructure for storing cancer research data generated by NCI funded programs. The GC provides secure and authorized storage and data sharing capabilities on the cloud via the NCI’s Cloud Resources for studies that are not a match for other CRDC Data Commons.',
    descriptionTextTitle: 'Cancer Data Service',
    callToActionText: 'Explore',
    callToActionLink: '/GeneralCommons', // This links to the "About" static page.
  },
  tile2: {
    alt: 'List of studies in the GC Portal',
    img: STATIC_CONTENT.landing.LANDING_TILE_2_IMAGE,
    titleText: 'STUDIES',
    descriptionText: 'View summaries of the studies submitted to GC.',
    descriptionTextTitle: 'Studies Listing',
    callToActionText: 'Go to studies listing',
    callToActionLink: '/studies', // This links to the studies Listing Page.
  },
  tile3: {
    alt: 'Form for submitting cancer research data',
    img: STATIC_CONTENT.landing.LANDING_TILE_3_IMAGE,
    titleText: 'SUBMIT DATA',
    descriptionText: 'To get started with a submission please submit a request on the CRDC Submission Portal.',
    descriptionTextTitle: 'CRDC HELPDESK',
    callToActionText: 'CRDC HELPDESK',
    callToActionLink: 'mailto:NCICRDC@mail.nih.gov', // Send email to CRDC help desk
  },
  tile4: {
    alt: 'Cancer data serach and cohort building tools',
    img: STATIC_CONTENT.landing.LANDING_TILE_4_IMAGE,
    titleText: 'GC DATA',
    descriptionText: 'Search all GC data and build cohorts of participants and samples from the studies hosted in the GC. The data files pertaining to these cohorts can then be accessed and analyzed on a NCI Cloud Resource platform.',
    callToActionText: 'Learn More',
    callToActionLink: '/data', // This links to the cases dashboard.
  },
};

// --------------- GraphQL query - Retrieve Landing page data --------------
export const GET_LANDING_PAGE_DATA_QUERY = gql`{
  searchSubjects{
    numberOfFiles
    numberOfSamples
    numberOfStudies
    numberOfSubjects
} 
  }
  `;
